import types from '../../types';

const transactios = (state = { loading: true }, { type, payload }) => {
  switch (type) {
    case types.GET_WALLET_TRANSACTIONS_START:
      return { ...state, loading: true };

    case types.GET_WALLET_TRANSACTIONS_SUCCESS:
      return { ...payload, loading: false };

    case types.GET_WALLET_TRANSACTIONS_FAILURE:
      return { ...state, loading: false };

    default:
      return state;
  }
};

export default transactios;
